import { Routes } from '@angular/router';
import { CreatePageComponent } from './create-page/create-page.component';
import { AuthGuard } from '../../../guards/auth.guard';
import { IsCompletedUserDataGuard } from '../../../guards/is-completed-user-data.guard';
import {
  opinionOnIssuingADecisionRoutes
} from './opinion-on-issuing-a-decision/opinion-on-issuing-a-decision.routes';
import { compensationForLossesRoutes } from './compensation-for-losses/compensation-for-losses.routes';
import { placementAdvertisingRoutes } from './placement-advertising/placement-advertising.routes';
import {
  opinionOnTheProjectOfTrafficOrgRoutes
} from './opinion-on-the-project-of-traffic-org/opinion-on-the-project-of-traffic-org.routes';
import {
  approvalOfTrafficOrganizationProjectsRoutes
} from './approval-of-traffic-organization-projects/approval-of-traffic-organization-projects.routes';
import {
  localisationDevicesUnrelatedToRoadRoutes
} from './localisation-devices-unrelated-to-road/localisation-devices-unrelated-to-road.routes';
import {
  locationOfDevicesUnrelatedToRoadRoutes
} from './location-of-devices-unrelated-to-road/location-of-devices-unrelated-to-road.routes';
import { carryingOutWorksRoutes } from './carrying-out-works-application/carrying-out-works.routes';
import {
  locationReconstructionOfExitRoutes
} from './location-reconstruction-of-exit-application/location-reconstruction-of-exit.routes';
import {
  publicInformationDisclosureRoutes
} from './public-information-disclosure/public-information-disclosure.routes';
import {
  notificationGeneralRemarksRoutes
} from './notification-general-remarks-road-marking/notification-general-remarks-road-marking.routes';
import {
  consentReconstructionRenovationOfBuildsRoutes
} from './consent-reconstruction-renovation-of-buildings/consent-reconstruction-renovation-of-buildings.routes';
import { responseToCallRoutes } from './response-to-call/response-to-call.routes';
import { documentsInformationRoutes } from './documents-information/documents-information.routes';
import { generalLetterRoutes } from './general-letter/general-letter.routes';
import {
  occupationOfLanePlacementConstructionObjectsRoutes
} from './occupation-of-lane-placement-construction-objects/occupation-of-lane-placement-construction-objects.routes';
import {
  takeOverLaneReconstructionOfExitRoutes
} from './take-over-lane-reconstruction-of-exit/take-over-lane-reconstruction-of-exit.routes';
import { permitForOversizeVehiclesRoutes } from './permit-for-oversize-vehicles/permit-for-oversize-vehicles.routes';
import { notificationOfEmergencyRoutes } from './notification-of-emergency/notification-of-emergency.routes';

export const applicationCreatePageRoutes: Routes = [
  {
    component: CreatePageComponent,
    path: 'e-uslugi/odpowiedz-na-wezwanie/skladanie-wniosku',
    children: responseToCallRoutes,
    data: {
      contentUrl: 'odpowiedz-na-wezwanie'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/uzupelnienie-dokumentow/skladanie-wniosku',
    children: documentsInformationRoutes,
    data: {
      contentUrl: 'uzupelnienie-dokumentow'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/pismo-ogolne/skladanie-wniosku',
    children: generalLetterRoutes,
    data: {
      contentUrl: 'pismo-ogolne'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/opinia-w-sprawie-wydania-decyzji/skladanie-wniosku',
    data: {
      contentUrl: 'opinia-w-sprawie-wydania-decyzji'
    },
    children: opinionOnIssuingADecisionRoutes,
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/odszkodowanie-za-straty/skladanie-wniosku',
    children: compensationForLossesRoutes,
    data: {
      contentUrl: 'odszkodowanie-za-straty'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/umieszczenie-reklamy/skladanie-wniosku',
    children: placementAdvertisingRoutes,
    data: {
      contentUrl: 'umieszczenie-reklamy'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/opinia-do-projektu-organizacji-ruchu-dla-drog-publicznych/skladanie-wniosku',
    children: opinionOnTheProjectOfTrafficOrgRoutes,
    data: {
      contentUrl: 'opinia-do-projektu-organizacji-ruchu-dla-drog-publicznych'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/zatwierdzenie-projektow-organizacji-ruchu-dla-drog-wewnetrznych/skladanie-wniosku',
    children: approvalOfTrafficOrganizationProjectsRoutes,
    data: {
      contentUrl: 'zatwierdzenie-projektow-organizacji-ruchu-dla-drog-wewnetrznych'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/lokalizacja-urzadzenia-niezwiazanego-z-funkcjonowaniem-drogi/skladanie-wniosku',
    children: localisationDevicesUnrelatedToRoadRoutes,
    data: {
      contentUrl: 'lokalizacja-urzadzenia-niezwiazanego-z-funkcjonowaniem-drogi'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/umieszczenie-urzadzenia-niezwiazanego-z-funkcjonowaniem-drogi/skladanie-wniosku',
    children: locationOfDevicesUnrelatedToRoadRoutes,
    data: {
      contentUrl: 'umieszczenie-urzadzenia-niezwiazanego-z-funkcjonowaniem-drogi'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/zajecie-pasa-prowadzenie-robot/skladanie-wniosku',
    children: carryingOutWorksRoutes,
    data: {
      contentUrl: 'zajecie-pasa-prowadzenie-robot'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/lokalizacja-przebudowa-zjazdu/skladanie-wniosku',
    children: locationReconstructionOfExitRoutes,
    data: {
      contentUrl: 'lokalizacja-przebudowa-zjazdu'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/awaryjne-zajecie-pasa-drogowego/skladanie-wniosku',
    children: notificationOfEmergencyRoutes,
    data: {
      contentUrl: 'awaryjne-zajecie-pasa-drogowego'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/udostepnienie-informacji-publicznej/skladanie-wniosku',
    children: publicInformationDisclosureRoutes,
    data: {
      contentUrl: 'udostepnienie-informacji-publicznej'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/zgloszenie-uwagi-ogolne-oznakowanie-drog/skladanie-wniosku',
    children: notificationGeneralRemarksRoutes,
    data: {
      contentUrl: 'zgloszenie-uwagi-ogolne-oznakowanie-drog'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/zgoda-przebudowa-remont-obiektow-budowlanych/skladanie-wniosku',
    children: consentReconstructionRenovationOfBuildsRoutes,
    data: {
      contentUrl: 'zgoda-przebudowa-remont-obiektow-budowlanych'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/zajecie-pasa-umieszczenie-obiektow-budowlanych/skladanie-wniosku',
    children: occupationOfLanePlacementConstructionObjectsRoutes,
    data: {
      contentUrl: 'zajecie-pasa-umieszczenie-obiektow-budowlanych'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/zajecie-pasa-budowa-przebudowa-zjazdu/skladanie-wniosku',
    children: takeOverLaneReconstructionOfExitRoutes,
    data: {
      contentUrl: 'zajecie-pasa-budowa-przebudowa-zjazdu'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/zezwolenie-przejazdy-pojazdow-nienormatywnych/skladanie-wniosku',
    children: permitForOversizeVehiclesRoutes,
    data: {
      contentUrl: 'zezwolenie-przejazdy-pojazdow-nienormatywnych'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  }
];
